"use client";

import React, { useState } from "react";
import HeroPage2 from "./components/HeroPage2";
import Switch from "./components/ButtonSwitch";
import CustomSelect from "../design1/components/ui/form/CustomSelect";
import { BranchSummaryCard } from "../design1/Branches";
import { PropertyCardSkeleton } from "./components/Skeletons/Design2PropertyCard";
import { useStaffDetails } from "src/app/lib/useStaffDetails";
import { useParams } from "next/navigation";
import Skeleton from "react-loading-skeleton";
import { VariantCard } from "../design1/components/Listing";
import Link from "next/link";
import { About } from "../design1/About1";
import CardGrid from "../../CardGrid";
import { PropertyType, StaffStats } from "src/types";
import Image from "next/image";
import NoSearchCriteria from "../../ui/NoSearchCriteria";
const StaffPage2 = () => {
  const [activeBranch, setActiveBranch] = useState<1 | 2>(1); // Default is 1
  const options = [
    { value: "apple", label: "Kano branch" },
    { value: "banana", label: "Maitama branch" },
    { value: "cherry", label: "Ojodu branch" },
  ];
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const handleSelect = (value: string) => {
    console.log("Selected:", value);
  };
  const search = useParams();
  const { id } = search;
  const toNum = parseInt(id as string);
  const { data: staff, isLoading } = useStaffDetails(toNum);
  console.log("staff", staff);
  if (!staff && !isLoading) {
    return <div>No staff available</div>;
  }
  return (
    <section>
      <HeroPage2 bgSize="cover" bgImage="/images/library.webp">
        <div className="text-center mb-4 text-white sm:flex-col flex items-center gap-14">
          {isLoading ? (
            <Skeleton height={234} width={230} />
          ) : (
            <div className="img rounded-xl border-[3px] overflow-hidden border-white">
              <Image
                height={230}
                width={230}
                className="max-h-[230px] object-cover w-[230px]"
                src={staff?.picture as string}
                alt="user image"
              />
            </div>
          )}

          <div className="flex flex-col text-left">
            <h1 className=" text-white font-semibold mt-4">
              {isLoading ? <Skeleton width={180} /> : staff?.name}
            </h1>
            <p className="h5 mb-6">
              {isLoading ? <Skeleton width={120} /> : staff?.real_estate_title}
            </p>
            <div className="flex sm:gap-1 md:flex-col  gap-6">
              <Link
                href={
                  staff?.phone
                    ? `tel:${staff.phone}`
                    : "No information available"
                }
                className="hover:underline flex gap-2 items-center"
              >
                <CallIcon />
                {isLoading ? (
                  <Skeleton width={140} />
                ) : staff?.phone ? (
                  staff.phone
                ) : (
                  "No phone available"
                )}
              </Link>
              <Link
                href={
                  staff?.email
                    ? `mailto:${staff.email}`
                    : "No information available"
                }
                className="hover:underline flex gap-2 items-center"
              >
                <EmailIcon />
                {isLoading ? <Skeleton width={180} /> : staff?.email}
              </Link>
            </div>
          </div>
        </div>
      </HeroPage2>
      <div className="wrapper py-10">
        <div className="first flex gap-8 mb-12 justify-between">
          <Switch
            button1Text="Overview"
            button2Text="Listing"
            activeState={activeBranch}
            onSwitch={(newState) => setActiveBranch(newState)}
          />
          {activeBranch === 1 && (
            <div
              className={`p-2 border border-themeColor ${
                activeBranch === 1 && "hidden"
              } rounded-md`}
            >
              <CustomSelect
                options={options}
                value={selectedValue}
                onChange={setSelectedValue}
                handleSelect={handleSelect}
                placeholder="All branches"
              />
            </div>
          )}
        </div>
        {activeBranch === 1 ? (
          <FirstTab
            loading={isLoading}
            values={staff?.stats as StaffStats}
            // desc={staff?.about_staff}
            desc={staff?.about_staff as string}
            name={staff?.name || "No name provided"}
          />
        ) : (
          <SecondTab properties={staff?.staffListing} loading={isLoading} />
        )}
      </div>
    </section>
  );
};
export default StaffPage2;

export function toRecord(stats: StaffStats): Record<string, string | number> {
  return { ...stats };
}

const FirstTab: React.FC<{
  name: string;
  desc: string;
  values: StaffStats;
  loading?: boolean;
}> = ({ name, desc, values, loading }) => {
  console.log("descripton", { name, desc, values, loading });

  return (
    <div className="grid-container">
      <About
        as="h3"
        loading={loading}
        remove
        title={`About ${name}`}
        data={desc}
        desc={desc || `No description available for ${name} at the moment.`}
        second
      />

      <BranchSummaryCard
        titleAs="h3"
        loading={loading}
        recent
        second
        {...{ title: "About Staff", values: toRecord(values) }}
      />
    </div>
  );
};

const SecondTab: React.FC<{
  loading: boolean;
  properties?: PropertyType[];
}> = ({ loading, properties = [] }) => {
  const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

  const options = [
    { value: "rent", label: "Rent" },
    { value: "short-let", label: "Shortlet" },
    { value: "sale", label: "Sale" },
  ];

  const [selectedValue, setSelectedValue] = useState<string>("rent");

  const isFilteredOut = selectedValue !== "rent" && !isDemo;

  if (loading) {
    return (
      <CardGrid gap={15} maxColumns={4}>
        {Array.from({ length: 4 }).map((_, index) => (
          <PropertyCardSkeleton key={index} />
        ))}
      </CardGrid>
    );
  }

  if (!loading && properties.length === 0) {
    return (
      <div className="flex justify-center items-center my-12">
        No properties available
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 flex justify-end">
        <span className="border-themeColor border p-2 rounded-md">
          <CustomSelect
            options={options}
            value={selectedValue}
            onChange={setSelectedValue}
            handleSelect={setSelectedValue}
            placeholder="All properties"
          />
        </span>
      </div>
      <CardGrid minCardWidth={300}>
        {isFilteredOut ? (
          <NoSearchCriteria />
        ) : (
          properties.map((item, index) => (
            <VariantCard className="!w-full" key={index} {...item} />
          ))
        )}
      </CardGrid>
    </div>
  );
};

export const CallIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1265_171773)">
        <path
          d="M16.625 5.25C18.0967 5.63754 19.4391 6.40874 20.5152 7.48483C21.5913 8.56092 22.3625 9.90335 22.75 11.375"
          fill="white"
        />
        <path
          d="M16.625 5.25C18.0967 5.63754 19.4391 6.40874 20.5152 7.48483C21.5913 8.56092 22.3625 9.90335 22.75 11.375"
          stroke="white"
          stroke-width="1.08642"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.75 8.74805C17.5569 9.23148 18.7666 10.4412 19.25 12.248L15.75 8.74805Z"
          fill="white"
        />
        <path
          d="M15.75 8.74805C17.5569 9.23148 18.7666 10.4412 19.25 12.248"
          stroke="white"
          stroke-width="1.08642"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.1052 16.7711C17.2263 16.6905 17.3657 16.6413 17.5107 16.6282C17.6556 16.615 17.8016 16.6382 17.9353 16.6956L23.0934 19.0067C23.2673 19.081 23.4124 19.2096 23.507 19.3733C23.6016 19.5369 23.6407 19.7268 23.6184 19.9146C23.4485 21.1844 22.8232 22.3494 21.8587 23.1928C20.8942 24.0362 19.6562 24.5005 18.375 24.4996C14.4299 24.4996 10.6464 22.9324 7.85679 20.1428C5.06719 17.3532 3.5 13.5696 3.5 9.62455C3.49902 8.34333 3.9634 7.10537 4.80677 6.14088C5.65014 5.17639 6.81511 4.55104 8.085 4.38111C8.27273 4.35881 8.46262 4.3979 8.62627 4.49254C8.78992 4.58718 8.91852 4.73228 8.99282 4.90611L11.3039 10.0686C11.3607 10.2012 11.3838 10.3458 11.3712 10.4895C11.3586 10.6332 11.3107 10.7715 11.2317 10.8922L8.89438 13.6714C8.81147 13.7965 8.76244 13.941 8.75209 14.0907C8.74173 14.2405 8.77041 14.3903 8.83531 14.5256C9.73985 16.3774 11.6539 18.2685 13.5111 19.1642C13.6471 19.2289 13.7977 19.2569 13.9479 19.2456C14.098 19.2343 14.2427 19.184 14.3675 19.0997L17.1052 16.7711Z"
          fill="white"
          stroke="white"
          stroke-width="1.08642"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1265_171773">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.6673 8.79102V19.8335C25.6674 20.7263 25.3263 21.5853 24.7138 22.2348C24.1014 22.8844 23.2639 23.2753 22.3727 23.3277L22.1673 23.3335H5.83398C4.94124 23.3336 4.08222 22.9925 3.43268 22.38C2.78314 21.7676 2.39219 20.9301 2.33982 20.0388L2.33398 19.8335V8.79102L13.3532 16.1375L13.4885 16.2145C13.648 16.2924 13.8231 16.3329 14.0007 16.3329C14.1782 16.3329 14.3533 16.2924 14.5128 16.2145L14.6482 16.1375L25.6673 8.79102Z"
        fill="white"
      />
      <path
        d="M22.1677 4.66602C23.4277 4.66602 24.5325 5.33102 25.1485 6.33085L14.001 13.7625L2.85352 6.33085C3.14611 5.85581 3.54802 5.4576 4.02575 5.16942C4.50348 4.88124 5.04318 4.71144 5.59985 4.67418L5.83435 4.66602H22.1677Z"
        fill="white"
      />
    </svg>
  );
};
